import { register } from 'swiper/element/bundle';
import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Swiper } from 'swiper/types';
import { NavController, Platform } from '@ionic/angular';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { Auth } from 'aws-amplify';
import { environment } from '../environments/environment';
import { ApiService } from './services';
import { SafariViewController } from '@awesome-cordova-plugins/safari-view-controller/ngx';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  providers: [Deeplinks],
})
export class AppComponent {
  page = 'home'
  showSidemenu = true;

  modal = '';

  newNotifications = 0;
  isAuth = false;

  menus: any = [];

  constructor(
    public router: Router,
    private apiService: ApiService,
    public nav: NavController,
    public platform: Platform,
    private deeplinks: Deeplinks,
    private safariViewController: SafariViewController,
    private zone: NgZone
  ) {

    if(!localStorage.getItem('guide_status') && localStorage.getItem('isAuth')) {
      router.navigate(['invite'], { replaceUrl: true });
    }

    platform.backButton.subscribeWithPriority(999, () => {
      nav.back();
    })

    this.checkMenu();
    this.checkIsAuth();

    if (!localStorage.getItem('menus')) {
      localStorage.setItem('menus', '[]')
    }

    router.events.subscribe((value: any) => {
      if (value.type !== 1 && value.type !== 2) return;

      let route = value.url.split('/');
      let lastRoute = route[route.length - 1];

      this.getNotifications();
      this.checkIsAuth();
      this.checkMenu();

      if (lastRoute != '') {
        if (
          window.location.href.includes('invitation') ||
          window.location.href.includes('recommendation') ||
          window.location.href.includes('onboarding') ||
          lastRoute == 'sign-up' ||
          lastRoute == 'sign-in' ||
          lastRoute == 'login' ||
          lastRoute == 'registration' ||
          lastRoute == 'reset' ||
          lastRoute == 'demo' ||
          lastRoute == 'proposals' ||
          lastRoute == 'regsuccess' ||
          lastRoute == 'invite' ||
          lastRoute == 'onboarding'
        ) {
          this.showSidemenu = false;
        } else {
          this.showSidemenu = true;
        }
      }

      this.page = lastRoute;
      // a1cc5262-557a-465a-afbc-43ecc8ac517e
    });

    const replaceStateOriginal = window.history.replaceState;
    window.history.replaceState = (data: any, unused: string, url?: string | URL | null) => {
      const urlToStore = url?.toString()?.includes(`${environment.androidScheme}://`) ? 'http://localhost/home' : url;
      replaceStateOriginal.bind(window.history)(data, unused, urlToStore);
    };

    // Hub.listen('auth', (data) => {
    //   const { payload } = data;
    //   if (payload?.event === 'signIn') {
    //     this.zone.run(async () => {
    //       await this.router.navigate(['home']);
    //     });
    //   }
    // });

    this.platform.ready().then(() => {
      if (!this.platform.is('cordova')) {
        return;
      }

      this.deeplinks.route({
        '/signin': 'signin',
      }).subscribe({
        next: async (match) => {
          this.zone.run(async () => {
            try {
              this.safariViewController.hide();
              const url = `/?${match.$link.queryString}`;
              await (Auth as any)._handleAuthResponse(url); // workaround inspired by https://github.com/aws-amplify/amplify-js/issues/3537
              window.location.reload(); // TODO: get rid of reload
              // setTimeout(async () => {
              //   try {
              //     console.log('Checking current authenticated user...');
              //     const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
              //     console.log('Authenticated user:', user);
              //     await this.router.navigate(['home']);
              //   } catch (error) {
              //     console.warn('Error fetching authenticated user:', error);
              //   }
              // }, 5_000);
            } catch (err) {
              this.safariViewController.hide();
              console.log('Auth failed!', err);

              await this.router.navigate(['home']);
              window.location.reload();
            }
          });
        },
        error: (nomatch) => {
          console.warn('Unmatched route', nomatch);
        }
      });

      

      this.deeplinks.route({
        '/signout': 'signout',
      }).subscribe({
        next: async (match) => {
          this.zone.run(async () => {
            try {
              this.safariViewController.hide();
              await this.router.navigate(['/sign-up']);
              window.location.reload(); // TODO: get rid of reload
              // setTimeout(async () => {
              //   try {
              //     console.log('Checking current authenticated user...');
              //     const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
              //     console.log('Authenticated user:', user);
              //     await this.router.navigate(['home']);
              //   } catch (error) {
              //     console.warn('Error fetching authenticated user:', error);
              //   }
              // }, 5_000);
            } catch (err) {
              this.safariViewController.hide();
            }
          });
        },
        error: (nomatch) => {
          console.warn('Unmatched route', nomatch);
        }
      });
    });
  }

  checkMenu() {
    this.menus = JSON.parse(localStorage.getItem('menus') as string);

    if (this.menus && this.menus.length === 0) {
      this.apiService.getMyMenu().subscribe((result: any) => {
        if (result?.list?.length > 0) {
          this.menus = result.list;
          localStorage.setItem('menus', JSON.stringify(this.menus));
        }
      });
    }
  }

  checkIsAuth() {


    if (localStorage.getItem('isAuth')) {
      this.isAuth = true;
    } else {
      this.isAuth = false;
      if (
        !window.location.href.includes('demo') &&
        !window.location.href.includes('invite') &&
        !window.location.href.includes('invitation') &&
        !window.location.href.includes('regsuccess') &&
        !window.location.href.includes('recommendation') &&
        !window.location.href.includes('onboarding') &&
        !window.location.href.includes('restaurant_page') &&
        !window.location.href.includes('restaurant')
        ) {
        this.router.navigate(['sign-up'], { replaceUrl: true });
      }
    }
  }

  getNotifications() {
    this.newNotifications = 0;

    this.apiService.getNotifications().subscribe((result) => {
      let newNotifs = result.items.filter((item) => item.isNew);
      this.newNotifications = newNotifs.length;
    })
  }
}
